import { useClientPortalAPI } from "@certn/api";
import { COBRANDING_SWR_OPTIONS } from "../../colours/hooks/useFetchCobranding";

export function useGetSavedBrandAssetUrls() {
  return useClientPortalAPI(
    "/api/internal/client-portal/customer-accounts/cobranding/",
    undefined,
    COBRANDING_SWR_OPTIONS
  );
}
